module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-600.214c401a.woff2";